import { render, staticRenderFns } from "./improvmentHint.vue?vue&type=template&id=3ab820f4&scoped=true"
import script from "./improvmentHint.vue?vue&type=script&lang=js"
export * from "./improvmentHint.vue?vue&type=script&lang=js"
import style0 from "./improvmentHint.vue?vue&type=style&index=0&id=3ab820f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab820f4",
  null
  
)

export default component.exports